import { addToGlobalThisRet } from "@plugins";
import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => initModelViewer());

function initModelViewer() {
    const modelViewerWrap = document.querySelector(".js-model-viewer-init");

    if (modelViewerWrap) {
        const modelViewer = modelViewerWrap.querySelector(".js-model-viewer-body");
        const zoomDecreaseButton = modelViewerWrap.querySelector(".js-model-viewer-zoom-decrease");
        const zoomIncreaseButton = modelViewerWrap.querySelector(".js-model-viewer-zoom-increase");

        if (modelViewer) {
            initModelViewerApi();

            if (zoomDecreaseButton) {
                zoomDecreaseButton.addEventListener("click", () => modelViewer.zoom(-3));
            }

            if (zoomIncreaseButton) {
                zoomIncreaseButton.addEventListener("click", () => modelViewer.zoom(3));
            }
        }
    }
}

function initModelViewerApi() {
    const script = document.createElement("script");

    script.type = "module";
    script.src = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js";

    document.head.appendChild(script);
}

addToGlobalThisRet(initModelViewer, "initModelViewer");
